export const HOLD_STOCK_ALLOWED_FROM = new Set([
  "draft",
  "incomplete",
  "quote_approval_pending",
  "availability_check",
  "request_delivery_timeline",
  "delivered",
  "partly_delivered",
  "partly_shipped",
  "shipped",
  "order_placed",
  "order_confirmed",
]);
